(function () {
    // 注册组件
    SR.component.extend('loadHistory', showHistory);

    function showHistory() {
        if (!SR.state.isSmartRobot || !SR.state.showHistoryQuestions) {
            return;
        }
        var questionsArray = localStorage.getItem('historyQuestions');
        questionsArray = !!questionsArray ? JSON.parse(questionsArray) : questionsArray;
        if (!questionsArray) {
            return;
        }
        (function filter() {
            var filterQuestions = [];
            var preQ = '';
            $.each(questionsArray, function(index, item) {
                if (item.q !== preQ) {
                    filterQuestions.push(item);
                }
                preQ = item.q;
            });
            questionsArray = filterQuestions;
        }());
        var questionsArrayCount = questionsArray.length;
        if (questionsArrayCount === 0){
            return;
        }
        SR.state.hasHistory = true;
        var lockScroll = false;
        var isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
        var isH5 = SR.dom.$doc.hasClass('h5-mode');
        var lastHistoryId;
        var winH = SR.data.deviceInfo.height;
        var triggerPosition = 0;
        var whiteSpaceH = 0;
        var historyCount = 3;
        var firstLoadPlaceholderH = 40;
        var statusBarH = 40;
        var throttleTimer;

        var $wrapper = SR.dom.$wrapper;
        var $scrollWrap = SR.dom.$scrollWrap;
        var $contentWrap = SR.dom.$contentWrap;
        var $statusBar = $('<div class="history-status-bar"><div class="spinner"><div class="bounce1"></div><div class="bounce2"></div><div class="bounce3"></div></div></div>').height(statusBarH);
        var triggerTip = isMobile ? '下滑加载历史' : '上滑加载历史';
        var $firstLoadPlaceholder = $('<div class="history-placeholder"><div class="tip">'+ triggerTip +'</div></div>');
        var $historyWrapper = SR.dom.$historyWrapper;
        var errorTimer;

        // init
        $firstLoadPlaceholder.css({
            'height': firstLoadPlaceholderH,
        });
        $contentWrap.css({
            'min-height': winH + firstLoadPlaceholderH - 20 - (isH5 ? 50 : 0)
        });
        $wrapper.css({
            'min-height': winH - (isH5 ? 50 : 0)
        }).prepend($firstLoadPlaceholder).append($statusBar);

        setTimeout(function () {
            // 避免定位失效的问题
            SR.dom.$scrollWrap.scrollTop(firstLoadPlaceholderH - 20);
        }, 10);
        setTimeout(function () {
            $firstLoadPlaceholder.find('.tip').fadeIn();
            bindScrollEvent();
        }, 400);

        function bindScrollEvent() {
            var touchStartX;
            var touchEndX;
            var touchStartY;
            var touchEndY;
            $scrollWrap.on('touchstart.history', function (e) {
                touchStartX = e.changedTouches[0].clientX;
                touchStartY = e.changedTouches[0].clientY;
            }).on('touchmove.history mousewheel.history scroll.history', function (e) {
                if (SR.state.askMode === 'staff') {
                    return;
                }
                if (clearTimeout) {
                    clearTimeout(throttleTimer);
                }
                throttleTimer = setTimeout(function () {
                    if (lockScroll) {
                        e.preventDefault();
                        return;
                    }
                    if (!isMobile) {
                        var top = $scrollWrap.scrollTop();
                        if (top <= triggerPosition) {
                            loadHistory();
                        }
                    }
                }, 200);
            }).on('touchend.history touchcancel.history', function(e) {
                if (SR.state.askMode === 'staff') {
                    return;
                }
                touchEndX = e.changedTouches[0].clientX;
                touchEndY = e.changedTouches[0].clientY;
                if (lockScroll) {
                    e.preventDefault();
                    return;
                }
                if (isMobile && Math.abs(touchStartY - touchEndY) > Math.abs(touchStartX - touchEndX) && touchEndY > touchStartY) {
                    var top = $scrollWrap.scrollTop();
                    if (top <= triggerPosition) {
                        loadHistory();
                    }
                }
            });
        }

        function unbindScrollSevent() {
            $scrollWrap.off('.history');
        }

        function loadHistory() {
            var historyIndex = SR.data.historyIndex !== undefined ? SR.data.historyIndex : 0;
            var questions = questionsArray.slice(historyIndex * historyCount, (historyIndex + 1) * historyCount);
            var questionsCount = questions.length;
            var currentIndex = (historyIndex + 1) * historyCount;
            var isLastPage = currentIndex >= questionsArrayCount;

            if (!questions || questionsCount === 0) {
                unbindScrollSevent();
                return;
            }
            
            lockScroll = true;
            $statusBar.show();

            var iNow = Date.now();
            var historyId = 'historyId-' + iNow;
            var containerId = 'containerId-' + iNow;
            var $historyWrap = $('<div class="history-wrap"></div>').css({'whiteSpaceH': whiteSpaceH}).attr('id', historyId);
            var $historyDone = $('<div class="history-done"><span class="tip">没有更多历史啦</span></div>');
            var $statusBarPlaceholder = $('<div class="status-placeholder"></div>').height(statusBarH);
            var $container = $('<div class="history-container"></div>').attr('id', containerId);
            var $statusPlaceholder = $('#' + lastHistoryId).find('.status-placeholder');

            $statusPlaceholder.find('.tip').text('');

            if (isLastPage) {
                currentIndex = questionsArrayCount;
                $historyWrap.prepend($historyDone);
                $statusBarPlaceholder.height(20);
            } else {
                $statusBarPlaceholder.append('<span class="tip">'+ triggerTip +'</span>');
            }
            $firstLoadPlaceholder.empty();
            $historyWrap.append($statusBarPlaceholder, $container);
            
            setTimeout(function () {
                $historyWrapper.prepend($historyWrap);
                window.askAll(questions, {
                    callbackHandle: function(askInfo, question) {
                        var date = SR.util.formatDate(question.d);
                        $('#' + askInfo.askId).before('<div class="history-date"><div class="date">'+ date +'</div></div>');
                    },
                    finalCallbackHandle: function () {
                        $statusPlaceholder.css({
                            'height': 20
                        });
                        var $answerContainer = $('#' + containerId);
                        var historyWrapH = $answerContainer.height() + statusBarH - 20;
                        $historyWrap.css({
                            'height': 'auto'
                        });
                        // 滑条操作
                        $scrollWrap.stop(false, false).animate({
                            scrollTop: historyWrapH
                        }, 0);
                        $scrollWrap.stop(false, false).animate({
                            scrollTop: historyWrapH - 200
                        }, 400, function () {
                            lockScroll = false;
                            historyIndex++;
                            SR.data.historyIndex = historyIndex;
                            lastHistoryId = historyId;
                        });
                        // 加载完成操作
                        $statusBar.hide();
                    },
                    scrollToAnswer: false,
                    answerContainerId: containerId,
                    isLoadHistory: true,
                });
            }, 300);
        }
    }
}());